import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { Loader2, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("admin@hedaplywoods.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const res = await login(email, password);
    if (res.ok) nav("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left: editorial image */}
      <div
        className="hidden md:block relative"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1758548157195-67d141468467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwd29vZCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MTA3MDY4OHww&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1A1A18]/35 via-transparent to-[#5E6033]/20" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="hed-overline" style={{ color: "#F2F0EA" }}>
            Hedaply · AI Product Studio
          </div>
          <h1 className="font-serif text-4xl mt-3 leading-tight">
            Where premium plywood meets precise intelligence.
          </h1>
          <p className="text-sm text-white/80 mt-3 max-w-md">
            Upload a brochure. Watch the catalog write itself.
          </p>
        </div>
      </div>

      {/* Right: form */}
      <div className="bg-[#FAFAF8] flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-sm hed-fade-up">
          <Logo size={42} />
          <div className="hed-overline mt-10">Admin access</div>
          <h2 className="font-serif text-3xl mt-2">Sign in to your studio</h2>
          <p className="text-sm text-[#5C5C54] mt-2">
            Manage products, QR codes and AI assistants for Heda Plywoods.
          </p>

          <form onSubmit={onSubmit} className="mt-10 space-y-6">
            <div>
              <label className="hed-overline block mb-2" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent border-b border-[#E8E6DF] focus:border-[#B5953B] focus:outline-none py-2 text-[#1A1A18] placeholder-[#A3A39A]"
                placeholder="you@hedaplywoods.com"
              />
            </div>
            <div>
              <label className="hed-overline block mb-2" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-transparent border-b border-[#E8E6DF] focus:border-[#B5953B] focus:outline-none py-2 text-[#1A1A18] placeholder-[#A3A39A]"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div
                data-testid="login-error-message"
                className="text-xs text-[#9E2A2B] border-l-2 border-[#9E2A2B] pl-3 py-1"
              >
                {error}
              </div>
            )}
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#1A1A18] hover:bg-[#2a2a26] disabled:opacity-50 text-white font-medium py-3 rounded-sm transition-colors"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : null}
              Enter Studio <ArrowRight size={14} strokeWidth={1.5} />
            </button>
          </form>

          <div className="mt-10 text-xs text-[#5C5C54]">
            Seeded admin · admin@hedaplywoods.com
          </div>
        </div>
      </div>
    </div>
  );
}
